import type { OAuthProvider } from '@/shared/config/routes';

export const OAUTH_CHANNEL = 'macswarm-oauth';
export const OAUTH_POPUP_NAME = 'macswarm-oauth';
export const OAUTH_POPUP_SIZE = { width: 520, height: 680 } as const;
export const OAUTH_CLOSED_CHECK_DELAY_MS = 400;

export const PROVIDER_NAMES: Record<OAuthProvider, string> = { google: 'Google', github: 'GitHub' };

export const RATE_LIMITED_MESSAGE = 'Too many links were asked for. Wait a minute and try again.';
